// extracted by mini-css-extract-plugin
export default {"text":"DeactivateAdvertDialog_text__omxPz"};